/**
 * Calendar item recurrence types
 */
export enum CalendarItemRecurrenceType {
	None = "none",
	Daily = "daily",
	Weekly = "weekly",
	Monthly = "monthly",
	Yearly = "yearly"
}
